// write the boiler plate code
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { newSdGroupApiBaseURL, newSdSupportSearchBaseURL } from '../../constants/index';
import axios from 'axios';


const initialState = {
    loading: false,
    error: '',
    newsData: [],
    filters: [],
    total: 0
};


export const getNewsRoomData = createAsyncThunk('newsRoomSlice/getNewsRoomData', async (query) => {
    try {
        return await axios.get(newSdGroupApiBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});


export const getSingleSegmentData = createAsyncThunk('newsRoomSlice/getSingleSegmentData', async (query) => {
    try {
        return await axios.get(newSdSupportSearchBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
})

const newsRoomSlice = createSlice({
    name: 'newsRoomSlice',
    initialState,
    reducers: {
        resetNewsRoomData: (state) => {
            state.newsData = [];
            state.total=[]
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getNewsRoomData.pending, (state) => {
            state.loading = true;
        })
            .addCase(getNewsRoomData.fulfilled, (state, action) => {
                state.loading = false;
                state.newsData = action.payload.grouped_docs;
                state.total = action.payload.total;
                state.filters = action.payload.facet_fields;
            })
            .addCase(getNewsRoomData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(getSingleSegmentData.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSingleSegmentData.fulfilled, (state, action) => {
                state.loading = false;
                state.newsData = action.payload.docs;
                state.total = action.payload.total;
                state.filters = action.payload.facet_fields;
            })
            .addCase(getSingleSegmentData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const {resetNewsRoomData } = newsRoomSlice.actions;

export default newsRoomSlice.reducer;
